exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.member_day_tabs[data-v-3128a453] {\n  padding: 12px;\n}\n", ""]);

// exports
